import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { requestConnectionsCounter } from 'redux/Dashboard/actions'
import IconWithTextCard from './IconWithTextCard'

class ConcurrentConnections extends React.Component {
    componentDidMount() {
        const { requestConnectionsCounter } = this.props

        requestConnectionsCounter()
    }
    render() {
        const { currentConnections } = this.props

        return (
            <IconWithTextCard title={currentConnections} subTitle="Concurrent connections" cardColor="red" icon="api" />
        )
    }
}

const mapStateToProps = ({ dashboard }) => ({
    currentConnections: dashboard.connectionsCounter.current
})

const mapActionsToProps = dispatch => ({
    requestConnectionsCounter: bindActionCreators(requestConnectionsCounter, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(ConcurrentConnections)
